import zhTw from '@/assets/lang/zhTw.json'
import vn from '@/assets/lang/vn.json'
import zhCn from '@/assets/lang/zhCn.json'
export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: 'vn',
  messages: {
    zhTw,
    vn,
    zhCn
  }
}))
